import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';


export class ApplicantVO {

  id: number;
  personId: number;
  firstName: string;
  lastName: string;
  middleName: string;
  suffix: string;
  firstNameAlias: string;
  lastNameAlias: string;
  suffixAlias: string;
  gender: string;
  height: string;
  weight: string;
  eyeColor: string;
  dob: Date;
  hairColor: string;
  placeOfBirth: string;
  ssn: string;
  type: number;
  driversLicense: string;
  isActive: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  applicantAddress: ApplicantAddressVO[];
  safeEnvTrainingList: SafeEnvTrainingVO[];
  liveScanRequest: LiveScanRequestVO;
  bgCheckRequest: BGCheckRequestVO;
  liveScanDecision: LiveScanDecisionVO;
  bgCheckDecision: BGCheckDecisionVO;
  heightInFt: number;
  heightInInch: number;
}
export class LiveScanDecisionVO {
  id: number;
  applicantId: number;
  informedDate: Date;
  ministryType: MinistryTypeVO;
  suggestedStartOfMinistry: Date;
  suggestedEndOfMinistry: Date;
  workWithChildren: string;
  workWithMoney: string;
  operateVehicle: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  liveScanDecisionNotesList: LiveScanDecisionNotesVO[];
  positionDescription: string;
}
export class LiveScanDecisionNotesVO {
  id: number;
  livescanDecisionId: number;
  notes: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;

}
export class ApplicantAddressVO {
  id: number;
  applicantId: number;
  address1: string;
  address2: string;
  addressType: string;
  city: string;
  state: string;
  zip: string;
  county: string
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
}
export class SafeEnvTrainingVO {
  id: number;
  applicantId: number;
  trainingStatus: string;
  dateOfTraining: Date;
  trainingExpires: Date;
  handbookSigned: Date;
  notes: string;
  isActive: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
}
export class LiveScanRequestVO {
  id: number;
  requestDate: Date;
  applicantId: number;
  ori: string;
  oca: string;
  orgName: string;
  orgType: string;
  orgId: number;
  applicationType: string;
  jobType: string;
  generatedBaic8016Form: string;
  workWithChildren: string;
  workWithMoney: string;
  operateVehicle: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  requestStatus: string;
  liveScanResponseList: LiveScanResponseVO[];
  
}
export class LiveScanResponseVO {
  id: number;
  isActive: string;
  liveScanRequestId: number;
  oca: string
  refDocument: string;
  fbiInquiryStatus: StatusCodeLookupVO;
  sid: string;
  notes: string;
  fbiAti: string;
  ati: string;
  inquiryStatus: StatusCodeLookupVO;
  responseFrom: string;
  dojDate: Date;
  fbiDate: Date;
  dateSubmitted: Date;
  responseDate: Date;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  livescanResponseAttachmentsList:LivescanResponseAttachmentsVO[];
}
export class LivescanResponseAttachmentsVO {
  id: number;
  livescanDecisionId: number;
  attachmentName: string;
  filesToUpload: Array<File>;
  isActive: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
}
export class LivescanResponseAttachmentsRes {
  apiResponseVO: ApiResponse;
  livescanResponseAttachmentsVOList: LivescanResponseAttachmentsVO[];
}

export class InquiryStatusVO {
  id: number;
  status: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;

}
export class LiveScanDecisionRes {
  apiResponseVO: ApiResponse;
  liveScanDecisionList: LiveScanDecisionVO[];
}
export class LiveScanResponseRes {
  apiResponseVO: ApiResponse;
  liveScanResponseVOList: LiveScanResponseVO[];
}
export class BGCheckRequestVO {
  id: number;
  requestDate: Date;
  applicantId: number;
  screeningoneReferenceId: string;
  jobType: string;
  orgName: string;
  orgType: string;
  orgId: number;
  requestStatus: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  bgCheckResponseList: BGCheckResponseVO[];
}

export class ApplicantRes {
  apiResponseVO: ApiResponse;
  applicantVOList: ApplicantVO[];
  bcia8016FormContent: string[];
}

export class Reports { 
  reportsId: string;
  isProcess: boolean
}

export class FileResponseVO {
  message: string;
  response: string;
  bcia8016FormContent: string[];
}
export class ApplicantSearchVO {
  id: number;
  name: string;
  firstName: string;
  lastName: string;
  dob: Date;
  checkType: string;
  ocaNumber: string;
  organizationId: Array<number>;
  seStatus: string;
  username: string;
  pageNo: number;
  pageSize: number;
}
export class ApplicantListingVO {
  id: number;
  firstName: string;
  lastName: string;
  dob: Date;
  ocaNumber: string;
  organizationName: string;
  type: string;
  requestedDate: Date;
  status: string;
  fbiStatus: string;
  safeEnvStatus: string;
  pending: boolean;
  completed: boolean;
  incomplete: boolean;
  retrain: boolean;
  needretrain: boolean;
}

export class ApplicantListingResponse {
  apiResponseVO: ApiResponse;
  applicantListingVOList: ApplicantListingVO[];
  count: number;
}

export class BGCheckDecisionVO {
  id: number;
  applicantId: number;
  informedDate: Date;
  ministryType: string;
  suggestedStartOfMinistry: Date;
  suggestedEndOfMinistry: Date;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  bgCheckDecisionNotesList: BGCheckDecisionNotesVO[];
}
export class BGCheckDecisionRes {
  apiResponseVO: ApiResponse;
  bgCheckDecisionVOList: BGCheckDecisionVO[];
}

export class BGCheckResponseVO {
  id: number;
  responseDate: Date;
  screeningoneReferenceId: string;
  decision: number;
  notes: string;
  results: string;
  requestStatus: string;
  lastUpdatedBy: string;
  lastUpdatedTime: any;
  createdBy: string;
  createdTime: any;
  bgCheckResponseAttachmentsList: BGCheckResponseAttachmentsVO[];
}

export class BGCheckDecisionNotesVO {
  id: number;
  bgCheckDecisionId: number;
  notes: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;

}
export class BGCheckResponseAttachmentsVO {
  id: number;
  bgCheckResponseId: number;
  attachmentName: string;
  filesToUpload: Array<File>;
  isActive: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
}
export class BGCheckResponseAttachmentsRes {
  apiResponseVO: ApiResponse;
  bgCheckResponseAttachmentsVOList: BGCheckResponseAttachmentsVO[];
}


export class BGCheckDecisionNotesRes {
  apiResponseVO: ApiResponse;
  bgCheckDecisionNotesList: BGCheckDecisionNotesVO[];
}

export class StatusCodeLookupVO {
  id: number;
  status: string;
  statusDescription: string;
}

export class StatusCodeLookupResponse {
  apiResponseVO: ApiResponse;
  statusCodeLookupVOList: StatusCodeLookupVO[];

}
export class DownloadFileVO {
  message: string;
  response: string;
  fileContent: string[];
  fileName: string;
}
export class BGCheckResponseRes {
  apiResponseVO: ApiResponse;
  bgCheckResponseList: BGCheckResponseVO[];
}
export class MinistryTypeVO {
  id: number;
  name: string;
  description: string;
}

export class MinistryTypeResponse {
  apiResponseVO: ApiResponse;
  ministryTypeVOList: MinistryTypeVO[];

}